const { VUE_APP_DOCS_URL } = import.meta.env

const api = {
  index: `${VUE_APP_DOCS_URL}/api.html`,
}

const apiKeys = {
  index: `${VUE_APP_DOCS_URL}/manage/api-keys.html`,
}

const authProviders = {
  github: `${VUE_APP_DOCS_URL}/reference/organizations/concepts/authentication/#github`,
  google: `${VUE_APP_DOCS_URL}/todo-google`,
  azuread: `${VUE_APP_DOCS_URL}/reference/organizations/concepts/authentication/#entradidazuread`,
  oidc: `${VUE_APP_DOCS_URL}/reference/organizations/concepts/authentication#oidc`,
  okta: `${VUE_APP_DOCS_URL}/todo-okta`,
  saml: `${VUE_APP_DOCS_URL}/todo-saml`,
}

const catalogRepositories = {
  create: `${VUE_APP_DOCS_URL}/reference/config-and-catalog-repository`,
  gitBranchCreate: `${VUE_APP_DOCS_URL}/cookbook/getting-started/platform-teams/organizations/gitops/#create-your-git-repository`,
}

const cloudAccounts = {
  index: `${VUE_APP_DOCS_URL}/reference/cloud-accounts`,
}

const cloudCostManagement = {
  index: `${VUE_APP_DOCS_URL}/reference/cloud-cost-management`,
  cloudCarbonFootprint: 'https://www.cloudcarbonfootprint.org/docs/methodology',
}

const infraPolicies = {
  index: `${VUE_APP_DOCS_URL}/govern/infrapolicy.html`,
  openPolicyLanguage: `https://www.openpolicyagent.org/docs/latest/policy-language/`,
}

const inventory = {
  index: `${VUE_APP_DOCS_URL}/discover/features/asset-inventory`,
  resources: `${VUE_APP_DOCS_URL}/reference/inventory/concepts/#how-to-use-it-in-a-pipelines-`,
}

const permissions = {
  organization: `${VUE_APP_DOCS_URL}/reference/organizations`,
  'organization:api_key': `${VUE_APP_DOCS_URL}/manage/api-keys.html`,
  'organization:child': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/child_organizations`,
  'organization:cloud_provider': `${VUE_APP_DOCS_URL}#`,
  'organization:config_repository': `${VUE_APP_DOCS_URL}reference/legacy-doc/get-started/configuration#config-repositories`,
  'organization:cost_explorer': `${VUE_APP_DOCS_URL}/manage/cloud-cost-management/overview.html`,
  'organization:credential': `${VUE_APP_DOCS_URL}/manage/credentials/credentials.html`,
  'organization:environment': `${VUE_APP_DOCS_URL}/reference/projects/concepts/environments`,
  'organization:external_backend': `${VUE_APP_DOCS_URL}/manage/infraview.html#configuration`,
  'organization:infra_policy': `${VUE_APP_DOCS_URL}/govern/infrapolicy.html`,
  'organization:inventory_resource': `${VUE_APP_DOCS_URL}/govern/inventory.html`,
  'organization:invitation': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions/#organization-level`,
  'organization:kpi': `${VUE_APP_DOCS_URL}/reference/projects/concepts/metrics#list-of-available-kpis`,
  'organization:member': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/interface#members`,
  'organization:pipeline': `${VUE_APP_DOCS_URL}/manage/pipeline/pipeline.html`,
  'organization:policy': `${VUE_APP_DOCS_URL}/govern/permissions.html#policies`,
  'organization:project': `${VUE_APP_DOCS_URL}/manage/project.html`,
  'organization:project:environment:component': `${VUE_APP_DOCS_URL}/reference/projects/concepts/components`,

  'organization:role': `${VUE_APP_DOCS_URL}/govern/permissions.html#roles`,
  'organization:service_catalog_source': `${VUE_APP_DOCS_URL}/reference/config-and-catalog-repository`,
  'organization:service_catalog': `${VUE_APP_DOCS_URL}/deploy/stack/stack.html`,
  'organization:team:member': `${VUE_APP_DOCS_URL}/govern/permissions.html#teams-level`,
  'organization:team': `${VUE_APP_DOCS_URL}/govern/permissions.html#teams-level`,
  menu: `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:projects': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:stacks': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:resources': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:observability': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:finops': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
  'menu:security': `${VUE_APP_DOCS_URL}/reference/organizations/concepts/permissions`,
}

const plugins = {
  registries: `${VUE_APP_DOCS_URL}/reference/plugins/concepts/plugin-registry`,
  manager: `${VUE_APP_DOCS_URL}/reference/plugins/concepts/plugin-manager`,
  creatingPlugins: `${VUE_APP_DOCS_URL}/reference/plugins/concepts/writing-a-plugin`,
}

const project = {
  billing: `${VUE_APP_DOCS_URL}/reference/cost-estimation`,
  environments: `${VUE_APP_DOCS_URL}/reference/projects/concepts/environments`,
  components: `${VUE_APP_DOCS_URL}/reference/projects/concepts/components`,
  scheduling: `${VUE_APP_DOCS_URL}/reference/projects/concepts/scheduling`,
  deploy: `${VUE_APP_DOCS_URL}/cookbook/getting-started/end-users/deploy`,
  index: `${VUE_APP_DOCS_URL}/manage/project.html`,
  infraView: `${VUE_APP_DOCS_URL}/manage/infraview.html`,
  kpis: `${VUE_APP_DOCS_URL}/reference/projects/concepts/metrics#list-of-available-kpis`,
  logs: {
    index: `${VUE_APP_DOCS_URL}/reference/projects/concepts/logs`,
    syntaxExamples: {
      aws: 'https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/FilterAndPatternSyntax',
      elasticsearch: 'https://www.elastic.co/guide/en/elasticsearch/reference/current/query-dsl-multi-match-query.html',
    },
  },
}

const roles = {
  manualActions: `${VUE_APP_DOCS_URL}/govern/permissions.html#manual-actions`,
  policies: `${VUE_APP_DOCS_URL}/govern/permissions.html#policies`,
}

const stacks = {
  readme: `${VUE_APP_DOCS_URL}/reference/stack-blueprint/concepts#readme-files`,
  overview: `${VUE_APP_DOCS_URL}/reference/stacks`,
  design: `${VUE_APP_DOCS_URL}/reference/stacks/concepts/design-stack`,
  stepByStep: `${VUE_APP_DOCS_URL}/cookbook/getting-started/devops-teams/stack-creation`,
  migrationGuide: `${VUE_APP_DOCS_URL}/cookbook/stacks-v4-migration`,
  versioning: `${VUE_APP_DOCS_URL}/reference/stacks/concepts/stack-versioning`,
  maintainers: `${VUE_APP_DOCS_URL}/reference/stacks/concepts/stack-versioning/#for-stack-maintainers`,
}

const terraform = {
  providers: 'https://www.terraform.io/docs/providers',
  state: 'https://www.terraform.io/docs/state',
  externalBackend: `${VUE_APP_DOCS_URL}/cookbook/getting-started/platform-teams/organizations/terraform-backend`,
}

const workers = {
  aws: `${VUE_APP_DOCS_URL}/manage/workers/aws.html`,
  azure: `${VUE_APP_DOCS_URL}/manage/workers/azure.html`,
  azureLink: 'https://portal.azure.com/#create/Microsoft.Template/uri/https%3A%2F%2Fraw.githubusercontent.com%2Fcycloid-community-catalog%2Fstack-external-worker%2Fmaster%2Fextra%2Fazure%2Fexternal-worker-azure-rm-template.json',
  baremetal: `${VUE_APP_DOCS_URL}/manage/workers/baremetal.html`,
  docker: `${VUE_APP_DOCS_URL}/manage/workers/docker.html`,
  flexeng: `${VUE_APP_DOCS_URL}/manage/workers/flexible-engine.html`,
  flexengZip: 'https://cycloid-cloudformation.s3-eu-west-1.amazonaws.com/flexible-engine.zip',
  gcp: `${VUE_APP_DOCS_URL}/manage/workers/gcp.html`,
  gcpSetup: 'https://cloud.google.com/deployment-manager/docs/step-by-step-guide/installation-and-setup',
  overview: `${VUE_APP_DOCS_URL}/manage/workers/workers.html`,
  onPremHelp: `${VUE_APP_DOCS_URL}/onprem/overview.html#cycloid-worker-installation`,
  troubleshooting: `${VUE_APP_DOCS_URL}/manage/workers/workers.html#troubleshooting`,
}

export default {
  api,
  apiKeys,
  authProviders,
  catalogRepositories,
  cloudAccounts,
  cloudCostManagement,
  infraPolicies,
  inventory,
  permissions,
  plugins,
  project,
  roles,
  stacks,
  terraform,
  workers,
}
